import { IStepGeometry, IVec3 } from '@stair-craft/common/util';

// Sawtooth point generator for a flight running along +Z (L/U flight 1).
// Walks: floor entry → for each step: up the riser, across the tread → final riser to flight exit.
export function buildFlightSawtoothZ(steps: IStepGeometry[], x: number, entryY: number, exitY: number, exitZ: number): IVec3[] {
    const first: IStepGeometry = steps[0];
    const points: IVec3[] = [{ x, y: entryY, z: first.position.z }];
    for (const step of steps) {
        points.push({ x, y: step.position.y, z: step.position.z });
        points.push({ x, y: step.position.y, z: step.position.z + step.treadDepth });
    }
    points.push({ x, y: exitY, z: exitZ });
    return points;
}
